import React from "react";
import classes from "./FollowButton.module.css";

const FollowButton = () => {
  return (
    <>
      <button className={classes.btn}>Follow</button>
    </>
  );
};

export default FollowButton;
